<template>
  <router-view />
</template>

<script>
export default {
  name: 'DictionariesIndex'
}
</script>
